import { request } from "./http";

export function getProducts() {
    return request("/api/products");
}

export function getProductById(id) {
    return request("/api/products/" + id);
}

export function getProductBySlug(slug) {
    return request("/api/products/slug/" + slug);
}

export function createProduct(body) {
    return request("/api/products", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(body)
    });
}

export function createProductMultipart(body) {
    var form = new FormData();

    function appendIf(name, val) {
        if (val != null && val !== "") { form.append(name, val); }
    }

    appendIf("name", body && typeof body.name === "string" ? body.name.trim() : "");
    if (body && body.price != null) {
        // istota, že je desatinná bodka (Spring -> double)
        var priceStr = String(body.price).replace(",", ".");
        form.append("price", priceStr);
    }
    appendIf("description", body && body.description);
    appendIf("category", body && typeof body.category === "string" ? body.category.trim() : "");
    if (body && body.quantity != null) {
        form.append("quantity", String(body.quantity));
    }
    appendIf("size", body && typeof body.size === "string" ? body.size.trim() : "");
    appendIf("wood", body && typeof body.wood === "string" ? body.wood.trim() : "");
    appendIf("subcategory", body && typeof body.subcategory === "string" ? body.subcategory.trim() : "");
    if (body && body.imageFile && body.imageFile instanceof File) {
        form.append("image", body.imageFile, body.imageFile.name);
    }

    // Content-Type NEnastavuj – prehliadač doplní boundary
    return request("/api/products", {
        method: "POST",
        headers: {}, // http.js pridá Accept + Authorization
        body: form
    });
}

export function deleteProduct(id) {
    return request("/api/products/" + id, { method: "DELETE" });
}

export function updateProductMultipart(id, body) {
    var form = new FormData();

    if (body && body.name != null)         { form.append("name", body.name); }
    if (body && body.price != null)        { form.append("price", body.price); }
    if (body && body.description != null)  { form.append("description", body.description); }
    if (body && body.category != null)     { form.append("category", body.category); }
    if (body && body.quantity != null)     { form.append("quantity", body.quantity); }
    if (body && body.size != null)         { form.append("size", body.size); }
    if (body && body.wood != null)         { form.append("wood", body.wood); }
    if (body && body.subcategory != null)  { form.append("subcategory", body.subcategory); }
    if (body && body.imageFile)            { form.append("image", body.imageFile); } // voliteľne

    return request("/api/products/" + id, {
        method: "PUT",
        headers: {},          // boundary nastaví prehliadač
        body: form
    });
}

export function updateProductJson(id, body) {
    return request(`/api/products/${id}`, {
        method: "PUT",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(body)
    });
}